import axios from "axios";

import moment from "moment";
import { formatHeaders } from "utils/Api";
import history from "components/common/navigation/AppHistory";
import rootURL from "utils/RootURL";

export const generateNewOffer = ({ t, languageUUID }) => {
  return {
    enabled: true,
    label: t("noName"),
    offer_plans: [],
    translations: [
      {
        default: true,
        language_uuid: languageUUID,
        description: "",
        name: t("noName"),
      },
    ],
    translations_indexes: {
      language_uuid: languageUUID,
      default: { true: [0] },
    },
  };
};

export const getSupportedPlatforms = (planOptions) => {
  const platforms = {
    okast: true,
    free: false,
    apple: false,
    google: false,
    retailer: true, // TODO: ADD Plan Options (Backend)
  };

  planOptions?.forEach((option) => {
    if (option.type === "ios_app" || option.type === "tvOS_app") {
      platforms.apple = true;
    }

    if (option.type === "android_app") {
      platforms.google = true;
    }
  });

  return platforms;
};

export const verifyPaymentExist = function ({
  offer_plan_uuid,
  token,
  t,
  onError,
}) {
  return new Promise((resolve) => {
    axios({
      url: rootURL(`/api/offer/v4/user/subscribe/${offer_plan_uuid}`),
      method: "GET",
      headers: formatHeaders(token, [
        {
          key: "Authorization",
          value: `Bearer ${token}`,
        },
      ]),
    })
      .then((res) => {
        const { new_subscription, error, subscription } = res.data;
        if (new_subscription && !error) {
          resolve(false);
        } else if (error) {
          onError(t("error:genericError"));
          resolve(true);
        } else {
          if (
            subscription &&
            subscription.status === "canceled" &&
            subscription.end_date
          ) {
            onError(
              t("error:error_cancelled", {
                date: moment(subscription.end_date).format("DD/MM/YYYY"),
              }),
            );
          } else {
            onError(t("error:error_resource_already_exists"));
          }
          resolve(true);
        }
      })
      .catch(() => {
        onError(t("error:genericError"));
        resolve(true);
      });
  });
};

export const redirectToOffers = function (mediaUuid, redirectUrl) {
  history.push({
    pathname: mediaUuid
      ? `/subscribe/offers/media/${mediaUuid}`
      : "/subscribe/offers/list",
    state: { redirectUrl },
  });
};

export const getOfferDescription = (
  t,
  { frequency_type, frequency, limit_date, resolution },
) => {
  resolution = resolution.toUpperCase();
  let frequencyStr = resolution;

  if (limit_date) {
    frequencyStr = `${moment(limit_date).format("LL")} - ${resolution}`;
  } else if (frequency) {
    frequencyStr = `${frequency} ${t(
      `editor-analytics:frequency_type.${frequency_type}`,
      {
        count: frequency,
      },
    )} - ${resolution}`;
  }

  return frequencyStr;
};
